export type ComboItem = {
    Key: number;
    Disp: string;
    Tag?: any; //付加情報
}

/**
 * SET_PART_DISテーブル
 */
export type SET_PART_DIS = {
    /**PLCNo. を取得または設定します。 */
    PLC_NO: number;
    /**シーケンスNo. を取得または設定します。 */
    SET_NO: number;
    /**実行フラグ を取得または設定します。 */
    RUN_FLG?: number;
    /**機器INDEX を取得または設定します。 */
    DEV_INDEX?: number;
    /**項目名称No. を取得または設定します。 */
    ITM_NAME_NO?: number;
    /**ロギング開始時刻 を取得または設定します。 */
    LOG_START?: Date;
    /**部分放電判定閾値(軽故障) を取得または設定します。 */
    LMT_L?: number;
    /**部分放電判定閾値(重故障) を取得または設定します。 */
    LMT_H?: number;
    /**最大値演算種別ID */
    MCLC_TYP_ID_MAX?: number;
    /**最大値異常内容No. */
    TYP_NO_MAX?: number;
    /**部分放電判定PD強度閾値(軽故障) を取得または設定します。 */
    LMT_L_PD?: number;
    /**部分放電判定PD強度閾値(重故障) を取得または設定します。 */
    LMT_H_PD?: number;
    /**PD強度演算種別ID */
    MCLC_TYP_ID_PD?: number;
    /**PD強度異常内容No. */
    TYP_NO_PD?: number;
    /**IPアドレス を取得または設定します。 */
    IP_ADR?: string;

    //変更フラグ
    isEdit: boolean;
};

/** レスポンス情報 */
export type ResponceDataType = {
    ResponseCode: number;
    ErrorCode: number;
    ResponseMessage: string;
    ErrorMessage: string;
};

export type PartialDischargeCollectionModel = {
    PartialDischargeCollectionItems: SET_PART_DIS[];
    NameDevSetLists: ComboItem[];
    MclcTypIdMaxDataList: ComboItem[];
    MclcTypIdPdDataList: ComboItem[];
    ResponceData: ResponceDataType;
    PartialDischargeCollectionType: number;
}

export type PartialDischargeResponceDataModel = {
    ErrorSetNo: number;
    ResponceData: ResponceDataType;
}
/**
 * 部分放電一覧の取得
 * @returns 
 */
export const GetPartialDischargeCollectionData = (): Promise<PartialDischargeCollectionModel> => {
    return new Promise((resolve, reject) => {
        fetch("api/PartialDischargeCollection/")
            .then((res) => {
                console.debug(["res", res]);
                if (!res.ok) {
                    let message = `データが見つかりませんでした status:${res.status}`;
                    console.debug(["message", message]);
                    throw new Error(message);

                }
                else {
                    console.debug(["res.json", res]);
                    return res.json();
                }
            })
            .then((result: PartialDischargeCollectionModel) => {
                console.debug(["then result", result]);
                if (result != null) {
                    if (result !== null) {
                        console.debug(["GetPartialDischargeCollectionData - ok", result]);
                    }
                    resolve(result);
                }
                else {
                    console.debug(["Invalidate response", result]);
                    reject('Invalidate response');
                }
            })
            .catch((error) => {
                console.debug(["error", error]);
                console.error(error.status);
                console.error(error);
                reject(error);
            })
    })

}

/**
 * 部分放電一覧の書換え
 * @param setPartDisList 
 * @returns 
 */
export const PutPartialDischargeCollectionData = (setPartDisList: SET_PART_DIS[]): Promise<PartialDischargeResponceDataModel> => {
    //console.debug(['SetSetPartDisList()', list]);
    return new Promise((resolve, reject) => {
        fetch("api/PartialDischargeCollection", {
            method: 'put',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(setPartDisList),
        })
            .then((res) => {
                if (!res.ok) {
                    let message = `データが見つかりませんでした status:${res.status}`;
                    reject(message);
                }
                return res.json();
            })
            .then((result: PartialDischargeResponceDataModel) => {
                console.debug(["PutPartialDischargeCollectionData - result ", result])
                resolve(result);
            })
            .catch((error) => {
                console.debug(["error", error]);
                console.error(error.status);
                console.error(error);
                reject(error);
            })
    });


}

